import React, { useState } from "react";
import fetch from 'node-fetch';
import "./styles.css";

const serverurl = 'https://tagger.visiblecharges.com/taggerservice';

const useForm = (callback: any, initialState: any) => {
  const [values, setValues] = useState(initialState);

  // onChange
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValues({ ...values, [event.target.name]: event.target.value });
  };


  // onSubmit
  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const errorstring = await callback(); // triggering the callback
    console.log('error', errorstring);
    if (errorstring !== '') {
      setValues({ ...values, errorstring: errorstring});
    };
  };

  // return values 
  return {
    onChange,
    onSubmit,
    values,
  };
};

function Login({postloginfunction}: any) {
    // defining the initial state for the form
    const initialState = {
      email: "",
      password: "",
      errorstring: ""
    };

    // getting the event handlers from our custom hook
    const { onChange, onSubmit, values } = useForm(
        loginUserCallback,
        initialState
    );

    // a submit function that will execute upon form submission
    async function loginUserCallback() {
      // send "values" to database
      console.log("posted form");
      const data = {'email': values.email,
		    'password': values.password}
      let endpoint = `${serverurl}/login`;
      let response;
      try {
	response = await fetch(endpoint, {
          method: 'POST',
          body: JSON.stringify(data),
          headers: { 'Content-Type': 'application/json' }
	});
      }
      catch (ex) {
	return "Error logging in";
      }
      if (response.status == 409 || response.status == 404) {
	try {
	  const json = await response.json();
	  return json.message;
	}
	catch (ex) {
	  return "Error logging in";
	}
      } else {
	if (response.status == 200) {
	  postloginfunction();
	  return '';
	}
	return 'Unknown error logging in.';
      }
    }

    return (
      <div className='login-form'>
	{(values.errorstring !== '') ? <div className='error'>{values.errorstring}</div> : ''}
        <form onSubmit={onSubmit}>
        <div className='input-field'>
	<label>Email address:
           <input
                name='email'
                id='email'
                type='email' placeholder='Email' onChange={onChange} required/>
	</label>
	</div>
	<div className='input-field'>
	<label>Password:
            <input
                name='password'
                id='password'
                type='password'
                placeholder='Password' onChange={onChange} required/></label>
	<br/>
            <button id="login-button" type='submit'>Login</button>
        </div>
      </form>
      </div>
    );
}

export default Login;
